export default __webpack_public_path__ + "static/media/capsule-open-small.14931ade.png";